import { useQuery, useQueryClient } from '@tanstack/react-query';

import { retentionKeys, retentionUsage, storageLevels } from './api';

// Sizes move with the background count (every few minutes), not with each request: no push
// exists for them, and none is polled. Every change made here refreshes all of them.
export const useRetentionUsage = () =>
  useQuery({ queryKey: retentionKeys.usage, queryFn: retentionUsage });

export const useStorageLevels = () =>
  useQuery({ queryKey: retentionKeys.levels, queryFn: storageLevels });

export const useRefreshStorage = () => {
  const client = useQueryClient();
  return () =>
    Promise.all([
      client.invalidateQueries({ queryKey: retentionKeys.all }),
      client.invalidateQueries({ queryKey: ['flows'] }),
      client.invalidateQueries({ queryKey: ['folders'] }),
    ]);
};
